import React, { Component } from 'react';
import Status from './Status';
import Validate from '../components/Validate';
import Accessories from '../components/Accessories';

class Close extends Component {
    constructor(props) {
        super(props);

        this.bp = this.props.current.serviceCall.businessPartner;
        console.log("bp", this.bp);
        this.changes = this.props.changes;
        console.log("changes", this.changes);
        this.accessories = Accessories.GetAccessories(this.bp, this.changes);

        console.log("Accessories", this.accessories);

        this.state = {
            mode: "",
            isFirstSave: props.current.isFirstSave,
            changes: this.props.changes,
            hasChanges: this.props.changes.HasChanges(),
            errorMessage: "",
            savedPicturesCount: 0,
            activities: props.changes.state.activities ? props.changes.state.activities : [],
            processes: this.props.current.processes ? this.props.current.processes : []
            
        };

        this.departments = [
            { code: 221, label: "Technische dienst (TD)" },
            { code: 150, label: "Back-office (BO)" },
            { code: 230, label: "Planning" },
            { code: 151, label: "CCC" }
        ];
    }

    componentDidMount() {

    }
    componentDidUpdate() {

    }
    componentWillUnmount() {

    }

    selectActivityDepartment(evt) {
        const value = evt.target.value;
        const name = evt.nativeEvent.target[evt.nativeEvent.target.selectedIndex].text;

        const activities = this.state.activities;

        // check if already exists
        if (activities.filter(p => p.name === name).length > 0) {
            alert (`Er staat reeds een activiteit klaar voor ${name}, wijzig de tekst indien nodig.`);
            return;
        }

        // create a base activity (action: Task, type: ToDo) and add it to the state
        var item = { assignedTo: { id: value }, action: "T", activityType: { code: 33 }, priority: "M", name: name, details: "", notes: "" };
        const newActivities = [...activities, item];
        this.setState({ activities: newActivities });

        // notify changes
        this.props.changes.SetActivities(newActivities);

    }
    handleChangeActivity(evt) {
        const name = evt.target.name;
        const value = evt.target.value;
        var activities = this.state.activities;
        var item = activities.filter(p => p.name === name);
        if (item.length === 0) return;
        item[0].details = value.length > 50 ? value.substring(0, 50) + ".." : value;       // store the first 50 characters as the title
        item[0].notes = value;
        this.setState({ activities: activities });

        // notify changes
        this.props.changes.SetActivities(activities);
    }

    getDepartment(code) {
        var item = this.departments.find(p => parseInt(p.code) === parseInt(code));
        if (item) return item.label;
        return "onbekend";

    }

    deleteActivity(idx) {
        if (this.state.activities[idx].notes === "") {
            this.deleteActivityConfirmed(idx);
        } else {
            // ask for confirmation
            this.setState({ mode: "confirmDelete", activityIndexToDelete: idx });
        }
    }

    deleteActivityConfirmed(idx) {
        const activities = this.state.activities;
        activities.splice(idx, 1);
        this.setState({ activities: activities, mode: "" });
        // notify changes
        this.props.changes.SetActivities(activities);
    }

    setPriority(evt) {
        const name = evt.target.name;

        var activities = this.state.activities;
        var item = activities.find(p => p.name === name);
        if (!item) return;
        item.priority = evt.target.checked ? "H" : "M";
        this.setState({ activities: activities });

        // notify changes
        this.props.changes.SetActivities(activities);
    }

    processAdded(newProcess) {
        this.setState({ isFirstSave: false, hasChanges: false, activities: [], processes: [...this.state.processes, newProcess] });
    }

    handleCheckbox(evt) {
        const name = evt.target.name;
        const value = evt.target.checked;
        this.setState({ [name]: value });
        this.props.changes.Set(name, value);  // save to the parent object, but keep the signature (!)
    }
    hasEmail() {
        // check if original BP has email, or if the changed details have an email
        var email = this.props.current.serviceCall.businessPartner.contact.email;
        if (this.props.changes.state.email) email = this.props.changes.state.email;
        return (email !== null &&
            email !== "" &&
            email.indexOf("@") > 0);
    }

    render() {
        //console.log("changes", this.props.changes);
        return <React.Fragment>
            {this.state.mode === "confirmDelete" &&
                <div>
                    <div className="message-back"></div>

                    <div className="message-front">

                        <p>Verwijderen van deze activiteit ?</p>

                        <div className="row">
                            <div className="col"></div>
                            <div className="col-auto">
                                <button className="btn btn-secondary" onClick={p => this.setState({ mode: "" })}>annuleren</button>
                                <button className="ms-2 btn btn-primary" onClick={p => this.deleteActivityConfirmed(this.state.activityIndexToDelete)}>bevestigen</button>
                            </div>
                        </div>


                    </div>
                </div>
            }

            <div className="row">
                <div className="col-md">
                    <h4>Afsluiten</h4>

                    {!this.state.hasChanges &&
                        <div>Er zijn geen nieuwe wijzigingen om op te slaan</div>
                    }
                    <div className="ms-2">


                        {false && !this.props.changes.state.cancelServiceCall &&
                            <div className="mt-4">
                                <label><input type="checkbox" name="createNewServiceCall" checked={this.props.changes.state.createNewServiceCall} onChange={this.handleCheckbox.bind(this)}></input> vervolgafspraak aanmaken</label>
                                {
                                    this.props.changes.state.createNewServiceCall && <div className="text-danger">
                                        <i className="fa-solid fa-circle-info"></i>  Deze bon wordt afgesloten en er wordt een nieuwe bon aangemaakt
                                    </div>
                                }
                            </div>
                        }



                        {this.props.changes.pictures && this.props.changes.pictures.length > 0 &&
                            <div className="mt-2">Totaal aantal nieuwe foto's: {this.props.changes.pictures.length}</div>
                        }
                        {this.state.activities && this.state.activities.length > 0 &&
                            <div className="mt-2">Totaal aantal nieuwe activiteiten: {this.state.activities.length}</div>
                        }
                    </div>

                    {this.state.processes && this.state.processes.some(process =>
                        process.changes && process.changes.activities && process.changes.activities.length > 0) &&
                        <h4 className="mt-2">Opgeslagen activiteiten</h4>
                    }

                    {/* previously assigned activities (if existing) */}
                    {this.state.processes && this.state.processes.map((process, idx) =>
                        process.changes && process.changes.activities && process.changes.activities.map((activity, idx2) => {
                            return <fieldset key={idx2}>
                                <div className="float-end">
                                    {activity.priority === "H" &&
                                        <i className="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>
                                    }
                                </div>
                                <div ><b>{this.getDepartment(activity.assignedTo.id)}</b></div>
                                {activity.notes.split("\n").map((par, idx3) => {
                                    return <div key={idx3}>{par}<br/></div>;
                                })}

                            </fieldset>

                        })
                    )
                    }

                    {/* checkbox to confirm PSTN information is left for customer */}
                    {this.props.changes.state.pstnInstalled === true && !this.hasEmail() &&
                        <div className="mt-4">
                            <i className="fa-solid ms-1 fa-triangle-exclamation text-danger"></i> Klant heeft geen email adres<br></br>
                            <label><input className="me-2 mt-2" type="checkbox" name="pstnCustomerInformed" checked={this.props.changes.state.pstnCustomerInformed} onChange={this.handleCheckbox.bind(this)}></input>PSTN informatie brief achtergelaten bij klant</label>
                        </div>
                    }
                    {this.props.changes.state.pstnInstalled === true && this.hasEmail() &&
                        <div>
                            <i className="fa-solid ms-1 fa-triangle-exclamation"></i> Klant krijgt PSTN informatie brief per email<br></br>
                        </div>
                    }


                    {/* enable to add new activities with select box*/}
                    <div className="mt-4">

                        Nieuwe activiteit toevoegen voor
                        <select className="form-control" name="listCode" value=""  onChange={this.selectActivityDepartment.bind(this)}>
                            <option value="">[selecteer]</option>
                            {this.departments.map((item, idx) => <option key={idx} value={item.code}>{item.label}</option>)}

                        </select>
                    </div>



                    {/* when all keks are removed, and all accessories are 0, then confirm that we are going to change status for EndCustomer */}
                    {/* {this.accessories.reduce((a,v)=> a=a+parseInt(v.value), 0) === 0 && 
                        <div className={this.state.confirmedEndClient ? "" : "text-danger"}><input type="checkbox" name="confirmedEndClient" className="me-2"
                        checked={this.state.confirmedEndClient}
                        onChange={this.handleCheckbox.bind(this)}></input>Ik bevestig dat alle abonnementen voor klant moeten worden be&euml;indigd.
                    </div>
                    } */}

                    {/* enable to edit the new activities  */}
                    {this.state.activities.map((item, idx) => {
                        return <div key={idx}>
                            <React.Fragment>

                                <button className="btn btn-danger float-end mt-3 mb-2" onClick={p => this.deleteActivity(idx)}><i className="fa-solid fa-trash"></i></button>
                                <span className="float-end mt-4 me-2">
                                    <label><input name={item.name} className="me-2" type="checkbox" checked={item.priority === "H"} onChange={p => this.setPriority(p, item)} />hoge prioriteit</label>
                                </span>
                            </React.Fragment>

                            <label className="mt-4">Activiteit voor {item.name}</label>


                            <textarea className="form-control" name={item.name}
                                onChange={this.handleChangeActivity.bind(this)} value={item.notes}></textarea>
                            <Validate value={item.notes} type="minLength" minLength="5"></Validate>

                        </div>
                    })}


                </div>
                <div className="col-md">
                    {this.state.mode === "saveError" &&
                        <div>
                            <h4 className="text-danger">Fout bij opslaan</h4>
                            {this.state.saveError !== "" &&
                                <p className="text-danger">{this.state.saveError}</p>
                            }

                        </div>
                    }
                    {this.state.mode === "saving" &&
                        <div>
                            Gegevens worden opgeslagen, een ogenblik geduld...
                        </div>
                    }
                    {this.state.mode === "savingpictures" && this.props.changes.pictures != null &&
                        <div>
                            Foto ({this.state.savedPicturesCount + 1}/{this.props.changes.pictures.length}) wordt opgeslagen, een ogenblik geduld...
                        </div>
                    }
                    {this.state.mode === "saved" &&
                        <div className="mt-4">
                            <p className="text-success">Gegevens zijn opgeslagen. Hieronder wordt de status getoond van de verwerking. Er kan nu worden teruggekeerd naar het overzicht.</p>
                        </div>
                    }


                    {this.state.processes.length > 0 && <React.Fragment>
                        <h4>Status</h4>
                        {this.state.processes.map((process, idx) =>
                            <div key={idx} className="card p-2 mb-2">
                                <Status id={process.id} process={process} key={idx} isAdmin={this.props.isAdmin}></Status>
                            </div>
                        )}
                    </React.Fragment>
                    }
                </div>
            </div>



        </React.Fragment>
    }
}


export default Close;